import { put, select, takeEvery } from 'redux-saga/effects'

import { UPDATE_DRAWABLES_MEASUREMENTS, UPDATE_OPENING_GROUPS_SUCCESS } from '../../../actions/drawable'
import { DocumentMapping } from '../../../models/documentMapping'
import { selectCurrentEstimatedOptionOverlayChunkIds } from '../../slices/2D'
import { selectDocumentMappings } from '../../slices/documents'
import { updateConflictResolutionFlag } from '../../slices/masterSetPlan'

export function* updateEstimatedOverlayChunkCompletionStatus() {
    const currentEstimatedOptionOverlayChunkIds: number[] = yield select(selectCurrentEstimatedOptionOverlayChunkIds)

    if (!currentEstimatedOptionOverlayChunkIds.length) return

    const documentMappings: DocumentMapping[] | null = yield select(selectDocumentMappings)

    if (!documentMappings) return

    const overlaidMappings = currentEstimatedOptionOverlayChunkIds
        .map((id) => documentMappings.find((mapping) => mapping.document_chunk_id === id))
        .filter((mapping): mapping is DocumentMapping => Boolean(mapping))

    // If any locked overlay was already complete, this geometry change makes that stale.
    if (overlaidMappings.some((mapping) => mapping.is_option && mapping.is_estimation_complete)) {
        yield put(updateConflictResolutionFlag(false))
    }
}

export function* watchForAnyMaterialChange() {
    yield takeEvery(
        [UPDATE_OPENING_GROUPS_SUCCESS, UPDATE_DRAWABLES_MEASUREMENTS],
        updateEstimatedOverlayChunkCompletionStatus
    )
}
